import axios from 'axios';
import apiConfig from '../../api.config';

export default function checkSftpConnection(body) {
  const {
    host,
    URIs: {checkSftpConnection},
  } = apiConfig;

  const uri = `${host}${checkSftpConnection}`;

  return axios
    .post(uri, body)
    .then(res => {
      return res.data;
    });
}
